import { cn } from '@app/shared/utils/common';

interface ImageCompositionProps {
  firstSrc: string;
  firstAlt: string;
  secondSrc: string;
  secondAlt: string;
  thirdSrc: string;
  thirdAlt: string;
  isSideImagesOpaque: boolean;
}

export function ImageComposition({
  firstSrc,
  firstAlt,
  secondSrc,
  secondAlt,
  thirdSrc,
  thirdAlt,
  isSideImagesOpaque,
}: ImageCompositionProps) {
  return (
    <div className="relative h-[203px] w-full max-w-[330px]">
      <img
        src={firstSrc}
        alt={firstAlt}
        className="absolute bottom-0 left-1/2 z-10 w-[171px] -translate-x-1/2"
      />
      <img
        src={secondSrc}
        alt={secondAlt}
        className={cn('absolute left-0 top-0 w-[138px]', !isSideImagesOpaque && 'opacity-80')}
      />
      <img
        src={thirdSrc}
        alt={thirdAlt}
        className={cn('absolute right-0 top-0 w-[138px]', !isSideImagesOpaque && 'opacity-80')}
      />
    </div>
  );
}
